import { MOTHERBOARD_PCB_THICKNESS, MOTHERBOARD_SOCKET_DECK_HEIGHT } from '../spatial/geometry.js';
import { motherboardStandardLandmarks } from '../spatial/motherboard-standard.js?v=20260817-pcieanchor10';

export function motherboardLandmarks(dims={},formFactor='ITX'){
  const standard=motherboardStandardLandmarks(dims,formFactor);
  const socketY=(MOTHERBOARD_PCB_THICKNESS/2)+MOTHERBOARD_SOCKET_DECK_HEIGHT;
  const surfaceY=(MOTHERBOARD_PCB_THICKNESS/2)+0.15;
  return {
    ...standard,
    socket:[standard.socketX,socketY,standard.socketZ],
    ramBank:[standard.ramX,surfaceY,standard.ramZ],
    ramSlots:standard.ramSlotXs.map((x,index)=>[x,surfaceY,standard.ramZ,index]),
    pcie:[standard.pcieCenterX,(MOTHERBOARD_PCB_THICKNESS/2)+1.2,standard.pcieZ],
    zones:{
      cpu:{x:standard.socketX,z:standard.socketZ,halfW:22.5,halfL:22.5},
      dimm:{x:standard.ramX,z:standard.ramZ,xs:[...standard.ramSlotXs],pitch:standard.ramPitch},
      pcie:{x0:standard.pcieStartX,x1:standard.pcieEndX,z:standard.pcieZ}
    }
  };
}

export function socketLandmarkLocal(dims={},formFactor='ITX'){return motherboardLandmarks(dims,formFactor).socket;}
export function pcieLandmarkLocal(dims={},formFactor='ITX'){return motherboardLandmarks(dims,formFactor).pcie;}
